export default "__VITE_ASSET__DBtFVrt___"